module.exports = __webpack_public_path__ + "img/電気回路_5_4_3.c596e947.png";